import type { ServicePageConfig } from 'src/sections/service/service-pages';
import { ServiceView } from 'src/sections/service/service-view';

export default function ServicePage(config: ServicePageConfig) {
  return <ServiceView {...config} />;
}
